import { Grid } from '@mui/material';

export const HeaderGrid = (props: React.ComponentProps<typeof Grid>) => (
    <Grid
        {...props}
        sx={{
            backgroundColor: '#F2F4F7',
            padding: '8px 8px',
            ...(props.sx || {})
        }}
    />
);

export const NormalGrid = (props: React.ComponentProps<typeof Grid>) => (
    <Grid
        {...props}
        sx={{
            padding: '0px 8px 0px',
            ...(props.sx || {})
        }}
    />
);
